var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-center content-denied-page"},[_c('h2',{staticClass:"font-weight"},[_vm._v("\n        You are not authorized to access this page.\n    ")]),_c('h4',[_vm._v("\n        Refer to your team leader for more information.\n    ")])])
}]

export { render, staticRenderFns }